var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vs-dialog',{attrs:{"not-close":"","auto-width":"","not-padding":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('div',{staticClass:"con-image"},[_c('img',{attrs:{"src":require(`../../assets/img/tutorial/${_vm.getImgApp}`),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }